import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <section className="section pt-24" data-testid="page-not-found">
            <div className="container-narrow text-center space-y-6">
                <p className="eyebrow">404</p>
                <h1 className="h1">That page didn't quite connect.</h1>
                <p className="lead">
                    The link you followed doesn't exist on The HR Connect. Try one of the paths below.
                </p>
                <div className="flex flex-wrap gap-3 justify-center pt-4">
                    <Link to="/" data-testid="nf-home" className="inline-flex items-center bg-brand text-brand-foreground hover:bg-brand-hover px-6 py-3 rounded-sm text-sm font-medium">Home</Link>
                    <Link to="/proposal" data-testid="nf-proposal" className="inline-flex items-center border border-foreground/80 px-6 py-3 rounded-sm text-sm font-medium hover:bg-surface">Submit a Proposal Request</Link>
                </div>
            </div>
        </section>
    );
}
